import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
  SETA: [
    "Agri", "Bank", "Ceta", "Chieta", "CATHS", "EW", "ETDP", "FP&M", "FASSET",
    "HW", "In", "LG", "Mer", "Mict", "Mqa", "PSETA", "Sas", "Service", "Teta",
    "W&R", "other"
  ],
  QUALIFICATIONS: [
    "Business Administration", "Project Management", "Contact Centre Support",
    "IT Technical Support", "Systems Development", "Interactive Media",
    "Automotive Repair and Maintenance", "Welding Application and Practice",
    "Electrical Engineering", "Professional Cookery", "Tour Guiding",
    "Travel Services", "Freight Handling", "Professional Driving",
    "Supply Chain Management", "Animal Production", "Plant Production",
    "Agriculture"
  ]
};

const Dropdown = ({
  label,
  items,
  type,
  isProjectDropdown,
  bottomLabel,
  showStamp,
  selected,
  setSelected,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedCircles, setSelectedCircles] = React.useState({});

  const toggleCircle = (item) => {
    setSelectedCircles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  return (
    <div className="flex flex-col w-full relative">
      <label className="md:text-[32px] font-bold text-[6px] text-black ">
        {label}
      </label>
      <p className="md:text-[20px] text-[6px] font-normal italic text-black ">
        {bottomLabel}
      </p>
      <div className="flex relative  w-fit md:mt-4">
        {/* Dropdown Button */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className={`xl:w-[520px] lg:w-[240px] md:w-[200px] w-[160px] h-[30px] md:h-[82px] bg-[#E7EBEB] text-black font-medium flex justify-between items-center px-2 md:px-4 rounded-l-[5px] `}
        >
          <span className="md:text-[32px] text-[8px]">{selected}</span>
          {showStamp && (
            <span className="bg-[#D9D9D9] text-black font-normal text-[6px] md:text-[32px] md:px-5 px-2 py-1 md:h-[82px] h-[30px] w-[60px] md:w-[170px] flex items-center rounded whitespace-nowrap">
              SETA
            </span>
          )}
        </button>

        {/* Icon Box */}
        <div
          className="w-[20px] h-[30px] md:h-[82px] md:w-[85px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-4  cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-2 md:w-10 md:h-[35px]"
          />
        </div>
      </div>

      {/* Dropdown List */}
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[590px] w-[160px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
          >
            <li className="flex items-center justify-between px-2 py-1 mb-2">
              <span className="text-[10px] md:text-[20px] font-semibold">
                Registration - Type of users
              </span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                alt="icon"
                className="md:w-[30px] md:h-[30px] h-[10px] w-[10px]"
              />
            </li>

            {items.map((item, index) => (
              <li
                key={index}
                className="flex items-center justify-between md:px-3 px-2 md:py-2 py-1 md:mt-1 rounded-md hover:underline cursor-pointer"
              >
                <span
                  onClick={() => {
                    setSelected(item);
                    setIsOpen(false); // Optional: close dropdown
                  }}
                  className="text-black text-[10px] md:text-[18px] cursor-pointer"
                >
                  {item}
                </span>
                <div
                  onClick={() => toggleCircle(item)}
                  className={`w-4 h-4 md:w-8 md:h-8 rounded-full ${
                    selectedCircles[item] ? "bg-[#03897B]" : "bg-gray-200"
                  }`}
                ></div>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

// Add showError and errorMessage props for error display
const Dropdown1 = ({
  selectedS,
  setSelectedS,
  selectedQ,
  setSelectedQ,
  showError,        // <-- new prop
  errorMessage,     // <-- new prop
}) => {
  return (
    <div>
      <div className="mb-6 mt-5 md:mt-2 font-Inter w-full mx-auto">
        <div className="grid grid-cols-2 gap-4">
          <Dropdown
            label="SETA"
            items={dropdownItems.SETA}
            type="SETA"
            bottomLabel="Select SETA"
            showStamp={true}
            selected={selectedS}
            setSelected={setSelectedS}
          />
          <Dropdown
            label="QUALIFICATIONS"
            items={dropdownItems.QUALIFICATIONS}
            type="QUALIFICATIONS"
            bottomLabel="Select qualifications"
            showStamp={false}
            selected={selectedQ}
            setSelected={setSelectedQ}
          />
        </div>
        {/* Error message for required validation */}
        {showError && (
          <div className="text-red-600 mt-2 text-xs text-center">
            {errorMessage || "This section is required. Please select both SETA and Qualification."}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown1;